/* System defined core library */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { SchedulingApiService } from '../../services/scheduling-api.service';
import { SelectedExamDetailService } from '../../services/selected-exam-detail.service';

/* User defined models */
import { Client } from '../../../../shared/models/scheduling/client.model';


@Component({
  selector: 'app-client-selector',
  templateUrl: './client-selector.component.html'
})
export class ClientSelectorComponent implements OnInit {

  /* User defined private/public variables  */
  public clientFrm: FormGroup;
  public submitted: boolean;
  public isClientSelected: boolean;
  public clients: Client[];

  /* Input-OutPut parameters decalartions */
  @Input() public inputLabel: string = '';
  @Input() public selectedClient: Client;
  @Output() public getSelectedClient: EventEmitter<Client> = new EventEmitter();

  /* Service subscriptions */
  client$: Subscription;
  translateLanguage$: Subscription;

  /* Constructor declaration with required injected services */
  constructor(
    private fb: FormBuilder,
    private schedulingApiService: SchedulingApiService,
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService
  ) {
    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      });

    this.isClientSelected = false;
  }

  /* Initialize the component & call require methods when component loaded first time. */
  ngOnInit() {
    this.clientFrm = this.fb.group({
      'selectClient': new FormControl('', Validators.required),
    });
    this.getClients();

    if (this.selectedExamDetailService.doesClientExist) {
      this.clientFrm.controls['selectClient'].disable();

    }
  }

  /* Get client list from API */
  getClients(): void {
    this.schedulingApiService.getClients().subscribe(clients => {
      this.clients = clients;
    });
  }

  /* Set selected client in shared service */
  changeClient(client: Client): void {
    if (client == undefined) {
      this.selectedExamDetailService.setProgram(null);
      this.selectedExamDetailService.setRegion(null);
      this.selectedExamDetailService.setState(null);
      this.selectedExamDetailService.setCountry(null);
      this.selectedClient = null;
    } else {
      this.selectedClient = client;
    }
    this.selectedExamDetailService.setClient(client);
    this.selectedExamDetailService.setPrograms(null);
    this.getSelectedClient.emit(client);
  }
}
